export const enrichRemoveBookingParams = (acc, changedEntity) => {
  const { shiftID } = changedEntity
  const params = { shift_id: shiftID }

  acc.push(params)
}
